





import Vue from 'vue'
import store from '../store'

export default Vue.extend({
  name: 'AppInstall',
  computed: {
    browserIs () {
      return store.state.browserIs
    }
  }
})
